<template>
    <form class="form-container-form" onsubmit="return false">
      <fieldset :disabled="!enabled">
        <div v-if="hasErrorMessage" class="alert alert-danger" role="alert">
            {{ errorMessage }}
        </div>
        <div v-if="hasSuccessMessage" class="alert alert-success" role="alert">
            {{ successMessage }}
        </div>
        <slot :enabled="enabled"></slot>
      </fieldset>
    </form>
</template>
<script>

function getFormData(config) {
  let data = {};
  for (let prop in config) {
    data[prop] = config[prop].value;
  }
  return data;
}

function setFormData(config, data) {
  for (let prop in config) {
    config[prop].value = data[prop];
  }
}

export default {
  props: {
    errorMessage: {
      typ: String,
      default: ''
    },
    successMessage: {
      type: String,
      default: ''
    },
    enabled: {
      type: Boolean,
      default: true
    },
    modelState: {},
    orientation: {
      type: String,
      default: null
    },
    config: {}
  },
  provide () {
    const self = this;
    return {
      getContainer: () => self.formContainer,
      modelState: (formTag) => self.getModelStateForForm(formTag)
    };
  },
  methods: {
    jsonToConfig (data) {
      setFormData(this.config, data);
    },
    configToJson() {
      return getFormData(this.config);
    },
    formToJson () {
      let formitems = this.$children;
      let json = {};
      for (let f of formitems) {
        if (f.$props['formTag']) {
          let val = f.$props['value'];

          if (f.$data['formType'] === 'date') {
            val = new Date(val);
          }
          json[f.$props['formTag']] = val;
        }
      }
      return json;
    },
    refreshVisibility () {
    },
    getModelStateForForm (formTag) {
      if (this.modelState != null) {
        let item = this.modelState.find(x => x.Key === formTag);
        if (item) {
          return item.Value;
        }
      }
      return '';
    },
    emitFormChange (child) {
      this.$emit('form-change', child);
    }
  },
  mounted () {
  },
  computed: {
    hasSuccessMessage () {
      return (this.successMessage !== null && this.successMessage.length > 0);
    },
    hasErrorMessage () {
      return (this.errorMessage !== null && this.errorMessage.length > 0);
    },
    formContainer () {
      const self = this;
      return {
        enabled: self.enabled,
        orientation: self.orientation,
        modelState: self.modelState,
        emitFormChange: self.emitFormChange
      };
    }
  },
  watch: {
    // modelState () {
    //   let formitems = this.$children;
    //   for (let f of formitems) {
    //     f.$data.validationError = this.getModelStateForForm(f.$props.formTag);
    //   }
    // }
  }
};
</script>
<style lang="scss">
form.form-container-form {
    background-color: transparent;
}
</style>
